module.exports = __webpack_public_path__ + "static/img/1.83ecd12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/1.png
// module id = mzHo
// module chunks = 0